import styles from './styles';
import { Select, withStyles } from '@material-ui/core';

export default withStyles(styles)(Select);
